import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import {Icon, Select, MenuItem} from "@material-ui/core";
import AppStore from "./AppStore";
import {FormattedMessage} from "react-intl";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,

    logoContainer: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(3),
        textAlign: 'center'
    },
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        //border: "1px solid yellow",
        //textAlign: 'left'
        //justifyContent: "flex-start"
    },
    userBox: {
        textAlign: 'center',
        marginBottom: theme.spacing(3),
    }
}));


function ListItemLink(props) {
    const { icon, primary, to } = props;

    const renderLink = React.useMemo(
        () => React.forwardRef((itemProps, ref) => <Link to={to} ref={ref} {...itemProps} />),
        [to],
    );

    return (
        <li>
            <ListItem button component={renderLink}>
                {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                <ListItemText primary={primary} />
            </ListItem>
        </li>
    );
}

function ResponsiveDrawer(props) {
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    let { tenant, resort } = props.match.params;
    const appStore = React.useContext(AppStore);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const handleDrawerClose = () => {
        setMobileOpen(false);
    };

    const menu = [
        {
            text : <FormattedMessage id="app.menu.home"/>,
            path : 'home',
            icon: 'home'
        },
        // {
        //     text : <FormattedMessage id="app.menu.account"/>,
        //     path : 'account',
        //     icon: 'account_balance'
        // },
        {
            text : <FormattedMessage id="app.menu.contact"/>,
            path : 'contact',
            icon: 'contact_support'
        }
    ];

    const drawer = (
        <div

        >
            <div className={classes.logoContainer}>
                <img
                    src={appStore.getResortData()['options']['urlLogo']}
                    alt={""}
                    width={"120"}
                />
            </div>
            <Typography variant={"overline"}>
                <div className={classes.userBox}>
                    {appStore.isLogged() && appStore.getUserName()
                    }

                </div>
            </Typography>
            <Divider />

            <List
                onClick={handleDrawerClose}
            >
                {menu.map(({text, path, icon}, index) => (
                    <ListItemLink key={index} to={`/${tenant}/${resort}/${path}`} primary={text} icon={<Icon>{icon}</Icon>} />
                ))}
            </List>
            <Divider />

            <List>
                <ListItem>
                    <ListItemIcon>
                        <Icon>language</Icon>
                    </ListItemIcon>
                    <ListItemText>
                        <Select
                            value={appStore.language}
                            onChange={(event) => appStore.setLanguage(event.target.value)}
                        >
                            {Object.keys(appStore.languageList).map((lang) => (
                                <MenuItem key={lang} value={lang}>{appStore.languageList[lang]['name']}</MenuItem>
                            ))}
                        </Select>
                    </ListItemText>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem button onClick={() => {
                    appStore.signOut(() => props.history.push(`/${tenant}/${resort}/login`));
                }}>
                    <ListItemIcon><Icon>exit_to_app</Icon></ListItemIcon>
                    <ListItemText><FormattedMessage id="app.menu.close-session"/></ListItemText>
                </ListItem>
            </List>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <AppStore.Provider value={appStore}>
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap>
                            {props.title}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <nav className={classes.drawer} aria-label="">
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            container={container}
                            variant="temporary"
                            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            variant="permanent"
                            open
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <div>
                        {props.children}
                    </div>
                </main>
            </div>
        </AppStore.Provider>
    );
}

ResponsiveDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default ResponsiveDrawer;
